export default __webpack_public_path__ + "static/media/icon-question-mark.899cb013.svg";